/** Thrall Conscript (35) — cheaper.png on hand card when deploy discount ticks */
export const THRALL_CONSCRIPT_CHEAPER_HAND_DURATION_MS = 1000;

export {
  CHEAPER_HAND_IMAGE_PATH,
  CHEAPER_HAND_CENTERED_IMAGE_STYLE,
  CHEAPER_HAND_OVERLAY_MATCH_ORDER_DESIGN_TRANSFORM,
} from './travelingSalesmanCheaperHandEffect';
